export default __webpack_public_path__ + "8520bab1c8d35ded5fca132ef25f8541.png";